module.exports = __webpack_public_path__ + "static/media/bg.c02c674e.png";